/* angular:styles/component:css;affd67a3445c8402499263c74d683c71e373f7a4d05c9e51ec9e2c4c97cd339d;/app/src/app/shared/animations/list-dropdown-animation.ts */
.max-height {
  overflow: hidden;
}
/*# sourceMappingURL=list-dropdown-animation.css.map */
